import { Button, ButtonSize, ButtonVariant } from "shared/components";
import {
  ArrowDown01Icon,
  ArrowUp01Icon
} from "@hugeicons-pro/core-stroke-rounded";

interface ModalFooterProps {
  isFullBreakdownVisible: boolean;
  onToggleFullBreakdown: () => void;
  onClose: () => void;
}

export const ModalFooter = ({
  isFullBreakdownVisible,
  onToggleFullBreakdown,
  onClose
}: ModalFooterProps) => {
  return (
    <div className="w-full border-y border-alpha-100 px-6 py-4 flex items-center justify-between gap-3 h-[72px]">
      <Button
        variant={ButtonVariant.BASE}
        size={ButtonSize.SM}
        onClick={onToggleFullBreakdown}
        HugeIcon={isFullBreakdownVisible ? ArrowUp01Icon : ArrowDown01Icon}
      >
        Check all criteria rules status
      </Button>

      <Button
        variant={ButtonVariant.PRIMARY}
        size={ButtonSize.SM}
        onClick={onClose}
        className="w-[103px]"
      >
        Got it
      </Button>
    </div>
  );
};
